var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"wh-100"},[(!_vm.companyStatus)?_c('div'):_c('enterprise',{staticClass:"wh-100",attrs:{"companyStatus":_vm.companyStatus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }